export default {
  "content": "<path d=\"M7 6.5h-.5a3 3 0 00-3 3v5a3 3 0 003 3h3.12a2 2 0 011.328.505l4.216 3.747-1.328 1.495L9.62 19.5H6.5a5 5 0 01-5-5v-5a5 5 0 015-5H7v2zM17.5 4.5a5 5 0 015 5v5a5 5 0 01-5 5H15v-2h2.5a3 3 0 003-3v-5a3 3 0 00-3-3H17v-2h.5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 9.5c3.094 0 6 2.042 6 5a1 1 0 01-1 1H7a1 1 0 01-1-1c0-2.958 2.906-5 6-5zm0 2c-1.87 0-3.231.913-3.759 2h7.518c-.528-1.087-1.889-2-3.759-2zM12 2.5a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};